import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = [ "output" ]
  static values = { showIf: String }

  connect() {
    if (!this.hasOutputTarget) return
    this.hide()
  }

  hide() {
    if (!this.hasOutputTarget) return
    this.outputTarget.classList.add('u-hidden')
    this.outputTarget.classList.remove('u-tableBody')
    const showButton = document.getElementById('show_button')
    if (showButton) showButton.classList.remove('u-hidden')
    return
  }

  show(event) {
    if (!this.hasOutputTarget) return
    this.outputTarget.classList.remove('u-hidden')
    this.outputTarget.classList.add('u-tableBody')
    event.target.classList.add('u-hidden')
    const packageNameField = document.getElementById('driving_schools_package_name')
    if (packageNameField) packageNameField.focus()
    return
  }
}
